import { h, Component } from 'preact';
import typographyStyle from '../style';
import style from './style';

const sizeToHeadingLevel = {
  'xs': 5,
  'sm': 4,
  'md': 3,
  'lg': 2,
  'xl': 1,
}

const Heading = ({
  children,
  size='md',
  color='dark',
  fontWeight='normal',
  textAlign='left',
  id,
  accessibilityLevel,
}) => {
    const classes = [
      style.heading,
      style[size],
      typographyStyle[color],
      typographyStyle[fontWeight],
      typographyStyle[textAlign],
    ];
    const headingLevel = accessibilityLevel ? accessibilityLevel : sizeToHeadingLevel[size];

		return h(
      `h${headingLevel}`,
      {'class': classes.join(' '), id},
      children
    )
}
export default Heading;



// WEBPACK FOOTER //
// ./components/typography/heading/Heading.js